import React, { useState } from "react";
import {
  IntroText,
  FormActionDrawer,
  Camera,
  ImageUpload
} from "../../../components";
import { Box, Typography, Link } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useTranslation } from "react-i18next";
import { isImageValidSize } from "../../../utils";

const VaxYesBoosterStepVaccineCard = ({
  onNext = () => {},
  setDrawerClearance,
  initialVaccineCardPhoto
}) => {
  const { t } = useTranslation();

  const [showImageUpload, setShowImageUpload] = useState(false);
  const [vaccineCardPhoto, setVaccineCardPhoto] = useState(
    () => initialVaccineCardPhoto
  );
  const [showImageFileSizeMsg, setShowImageFileSizeMsg] = useState(false);

  const handlePhoto = photo => {
    if (isImageValidSize(photo, 2000)) {
      setVaccineCardPhoto(photo);
      setShowImageFileSizeMsg(false);
    } else {
      setShowImageFileSizeMsg(true);
    }
  };

  return (
    <Box data-cy="upload-booster-image">
      <IntroText>
        {t("vax_yes.vax_yes_booster_vaccine_card.intro_text")}
      </IntroText>
      <Typography align="center" paragraph>
        {t("vax_yes.vax_yes_booster_vaccine_card.secondary_text")}
      </Typography>
      {showImageFileSizeMsg && (
        <Box my={2}>
          <Alert severity="error">
            Unable to accept photo. Please make sure that your image is less
            than 2mb.
          </Alert>
        </Box>
      )}
      {showImageUpload ? (
        <ImageUpload
          onSuccess={photo => setVaccineCardPhoto(photo)}
          buttonText={t(
            "vax_yes.vax_yes_booster_vaccine_card.button_upload_label"
          )}
        />
      ) : (
        <>
          <Camera
            photo={vaccineCardPhoto}
            onTakePhoto={photo => handlePhoto(photo)}
            sizeFactor={0.9}
            imageCompression={0.7}
          />
          {vaccineCardPhoto && (
            <Box textAlign="center" mt={1}>
              <Link
                onClick={() => setVaccineCardPhoto()}
                component="button"
                data-cy="button-retake-photo"
              >
                {t("vax_yes.vax_yes_booster_vaccine_card.retake_photo")}
              </Link>
            </Box>
          )}
        </>
      )}
      <Box textAlign="center" mt={2}>
        {!showImageUpload ? (
          <Typography>
            {t("vax_yes.vax_yes_booster_vaccine_card.upload_image_text")}{" "}
            <Link
              onClick={() => {
                setShowImageUpload(true);
                setShowImageFileSizeMsg(false);
              }}
            >
              {t("vax_yes.vax_yes_booster_vaccine_card.upload_image_link")}
            </Link>
          </Typography>
        ) : (
          <Typography>
            {t("vax_yes.vax_yes_booster_vaccine_card.take_photo_text")}{" "}
            <Link
              onClick={() => {
                setShowImageUpload(false);
                setVaccineCardPhoto("");
              }}
            >
              {t("vax_yes.vax_yes_booster_vaccine_card.take_photo_link")}
            </Link>
          </Typography>
        )}
      </Box>
      <FormActionDrawer
        handleNext={() =>
          onNext({
            vax_image: vaccineCardPhoto
          })
        }
        setDrawerClearance={setDrawerClearance}
        nextButtonLabel={t("vax_yes.vax_yes_booster_vaccine_card.button_next")}
        disabled={!vaccineCardPhoto}
      />
    </Box>
  );
};

export { VaxYesBoosterStepVaccineCard };
